export default {"src":"/_next/static/media/logo.39ad0867.svg","height":120,"width":170,"blurWidth":0,"blurHeight":0};